export const setAnswer = function (key, value) {
  let answers = store.getAnswers();
  answers[key] = value;
  store.set('answers', answers);
};
